<mat-sidenav-container
  class="h-100"
  [hasBackdrop]="isSmallWidth$ | async"
  (backdropClick)="toggleSidenav()"
  #navContainer
>
  <mat-sidenav
    class="sidenav"
    *ngIf="isAuthenticated$ | async"
    [opened]="isSidenavOpened$ | async"
    [mode]="(isSmallWidth$ | async) ? 'over' : 'side'"
  >
    <mat-nav-list class="nav-list">
      <div class="sidenav-section logo-container">
        <ng-container *ngIf="empresaSelecionada$ | async as empresa">
          <a
            routerLink="/dashboard"
            class="fs-2 fw-normal"
            *ngIf="!empresa.urlFoto"
          >
            {{ appName }}
          </a>
          <ng-container *ngIf="empresa.urlFoto">
            <a routerLink="/dashboard">
              <img
                class="logo-image"
                [src]="empresa.urlFoto"
                [alt]="empresa.nomeFantasia"
              />
            </a>
            <span class="by-hub-text"> by {{ appName }}</span>
          </ng-container>
        </ng-container>
      </div>

      <div
        class="sidenav-section user-info-container"
        *ngIf="usuario$ | async as user"
      >
        <img
          *ngIf="user.urlFoto"
          [src]="user.urlFoto"
          [alt]="user.nome"
          class="user-image"
        />

        <img
          *ngIf="!user.urlFoto"
          [src]="'../../../../../assets/images/user-avatar.png'"
          [alt]="user.nome"
          class="user-image"
        />

        <div class="flex-grow-1 d-flex justify-content-between h-100">
          <div class="d-flex flex-column px-2 align-self-center">
            <p class="user-name mb-0 fs-8">
              {{ user.nome | capitalizeWords }}
            </p>
            <small class="user-name text-gray-600 fs-9">
              {{ user.cargo }}
            </small>
          </div>

          <button mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger>
            <mat-icon>settings</mat-icon>
          </button>

          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item routerLink="/usuario">
              <mat-icon>manage_accounts</mat-icon>
              Minha conta
            </button>
            <button mat-menu-item (click)="signOut()">
              <mat-icon>logout</mat-icon>
              Sair
            </button>
          </mat-menu>
        </div>
      </div>

      <div class="menu-items-container">
        <app-sidenav-menu-item
          *ngFor="let menuItem of menuItems$ | async"
          [item]="menuItem"
          [isMenuActivated]="activatedItem === menuItem"
          (clicked)="toggleActivatedMenu(menuItem)"
          (subMenuClicked)="clearActivatedMenu()"
          (opened)="onMenuItemOpened($event)"
        />
      </div>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content class="content">
    <ng-content />
  </mat-sidenav-content>
</mat-sidenav-container>
